<template>
    <templateLogin>
        <div class="header content-right">
            <span>Ainda não tem uma conta?</span>
            <router-link to="criar-conta">Criar conta como corretor</router-link>
        </div>
        <div class="body">
            <div class="box-login">
                <div class="logo">
                    <img height="60" :src="logoUrl"/>
                    <!-- <img height="60" src="../../assets/imgs/facilita.svg"> -->
                </div>
                <form action="#" method="post" @submit.prevent="login">
                    <div v-show="message" class="message mb-15" v-html="message"/>
                    <ui-input
                        v-model="form.data.email"
                        :class="{ 'error': form.errors ? form.errors['email'] : false }"
                        value="raphael.nikson@gmail.com"
                        label="E-mail:"
                        size="md3"
                        type="text"
                        refer="username"/>
                    
                    <div class="reset-link">
                        <ui-input
                            ref="password"
                            v-model="form.data.password"
                            :class="[{ 'error': form.errors ? form.errors['password'] : false }, 'mb-15']"
                            label="Senha:"
                            size="md3"
                            type="password"
                            @click="clearMessage()"/>
                    </div>

                    <div class="control">
                        <ui-button
                            type="submit"
                            design="lg primary block"
                            :class="load" @click="login">
                            Entrar
                        </ui-button>
                    </div>

                    <div class="remember">
                        <router-link to="solicitar-alteracao">Esqueceu sua senha?</router-link>
                    </div>
                </form>
            </div>
        </div>
    </templateLogin>
</template>
<script>
    import { uiButton } from '@/components/ui/buttons'
    import { uiInput } from '@/components/ui/form'
    import templateLogin from '@/templates/page-login'
    import { mapActions } from 'vuex'
    import { offline } from '@/services/axios'
    
    import { storage } from '@/services/storage'
    import helpers from '@/mixins/helpers'

    export default {
        name: 'ui-login',
        components: { templateLogin, uiButton, uiInput },
        mixins: [ helpers ],

        data() {
            return {
                show: false,
                logoUrl: null,
                form: {
                    data: {
                        email: '',
                        password: '',
                        remember: false,
                        validate: true
                    },
                    errors: null
                },
                message: '',
                title: '',
                load: '',
            }
        },
        created(){
            this.checkModules()
            let logo = storage.get('client_logo');
            if(logo){
                this.logoUrl = logo
            }
        },

        methods: {
            ...mapActions('auth', ['doLogin']),
            async login(event){
                event.preventDefault()
                this.load       = 'loading'
                this.message    = ''
                try {
                    await this.doLogin(this.form.data)
                } catch (error) {
                    this.load = ''
                    this.form.errors = null
                    if (error.response.data.message) {
                        this.message = error.response.data.message
                    } else if (error.response.data.code) {
                        switch (error.response.data.code) {
                            case 401.2:
                                this.message = 'Email ou senha incorretos'
                                break
                            default:
                                this.message = `Erro desconhecido. Código: ${error.response.data.code}`
                        }
                    } else if (error.response.status === 412 && error.response.data.msg) {
                        this.form.errors = error.response.data.msg
                        // Mostra somente a primeira mensagem de erro
                        this.message = Object.values(this.form.errors)[0][0]
                    } else if (error.response.data.error) {
                        switch (error.response.data.error) {
                            case 'invalid_credentials':
                                this.message = 'Usuário ou senha incorretos'
                                break;
                            default:
                                this.message = 'Não foi possível autenticar'
                                break;
                        }
                    } else {
                        if (["Usuário inativo."].includes(error.response.data.msg)) {
                            this.$router.push({
                                name: 'message',
                                params: {
                                    title:   error.response.data.msg,
                                    text:    'O seu acesso está bloqueado temporariamente.',
                                    icon:    'fal fa-lock-alt',
                                    type:    'default  ',
                                    btnUrl:  '/',
                                    btnText: 'Tentar mais tarde'
                                }
                            })
                        }
                    }
                }
            },
            clearMessage(){
                this.message = ""
            },
            /**
             * Carrega as configurações necessárias para montar o painel
             */
            checkModules() {
                offline.getConfigurations().then(response => {
                    let data = response.data
                    let newObject = {}
                    for(const key in data) {
                        newObject[data[key].name] = data[key].value != '' ? data[key].value : data[key].value_long
                    }
                    storage.set('get-configs-data',JSON.stringify(newObject))
                    const clubpoints = {}

                    for (var prop in data) {
                        if (Object.prototype.hasOwnProperty.call(data, prop)) {
                            if (data[prop].name === 'nameBusiness') {
                                storage.set('client_name', data[prop].value)
                            }

                            if (data[prop].name === 'clubName') {
                                clubpoints.name = data[prop].value
                            }

                            if (data[prop].name === 'clubPoints') {
                                clubpoints.status = data[prop].value
                            }

                            if (data[prop].name === 'clubPointsName') {
                                clubpoints.points_label = data[prop].value
                                storage.set('club', JSON.stringify(clubpoints))
                            }

                            if(data[prop].name === 'menuAllowed'){
                                storage.set('allowed_menu', data[prop].value_long)
                            }

                            if (data[prop].name === 'allowedApps') {
                                storage.set('allowed_apps', data[prop].value_long)
                            }

                            if (data[prop].name === 'proposalSettings') {
                                storage.set('proposal_settings', JSON.stringify(data[prop].value_long))
                            }

                            if (data[prop].name === 'api_data') {
                                storage.set('api_config', JSON.stringify(data[prop].value_long))
                            }

                            if (data[prop].name === 'brandLogo') {
                               this.logoUrl = this.getImgCDN(data[prop].value)
                               storage.set('client_logo', this.logoUrl)
                            }

                            if (data[prop].name === 'brokerApprove') {
                                storage.set('broker_approve', data[prop].value)
                            }

                            if (data[prop].name === 'fieldIdentifier') {
                                storage.set('field_identifier', data[prop].value)
                            }

                            if (data[prop].name === 'fieldCpf') {
                                storage.set('field_cpf', data[prop].value)
                            }

                            if (data[prop].name === 'configsQueueReserves') {
                                storage.set('configs_queue_reserves', JSON.stringify(data[prop].value_long))
                            }

                            if (data[prop].name === 'labelBroker') {
                                storage.set('label_broker', data[prop].value)
                            }

                            if (data[prop].name === 'labelManager') {
                                storage.set('label_manager', data[prop].value)
                            }

                            if (data[prop].name === 'labelSupervisor') {
                                storage.set('label_supervisor', data[prop].value)
                            }

                            if (data[prop].name === 'labelCollaborator') {
                                storage.set('label_collaborator', data[prop].value)
                            }

                            if (data[prop].name === 'labelAdmin') {
                                storage.set('label_admin', data[prop].value)
                            }

                            if (data[prop].name === 'funnelMongo') {
                                storage.set('funnel_mongo', JSON.stringify(data[prop].value_long))
                            }

                            if (data[prop].name === 'cacheVersion') {
                                storage.set('cache_version', data[prop].value)
                            }

                            if (data[prop].name === 'configMirrorFacilita') {
                                storage.set('config_mirror_facilita', JSON.stringify(data[prop].value_long))
                            }

                            if (data[prop].name === 'betaFeatures') {
                                storage.set('beta_features', JSON.stringify(data[prop].value_long))
                            }

							if (data[prop].name === 'dataReserve') {
								storage.set('data_reserve', JSON.stringify(data[prop].value_long))
							}
                            if (data[prop].name === 'dataPreSales') {
                                storage.set('data_pre_sales', JSON.stringify(data[prop].value_long))
                            }
                        }
                    }
                })
            },
        }
    }
</script>


